<template>
  <div>
    <v-container>
      <employee-selection :show-dense="false" :show-select="true"></employee-selection>
      <br />
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import EventBus from "../../../events/eventBus";
import moment from "moment";
const EmployeeSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/Selection");

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmployees: [],
    loading: false
  }),
  components: {
    EmployeeSelection
  },
  computed: {
    empCodes() {
      return this.selectedEmployees.join(", ");
    }
  },
  methods: {
    exportReport() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}/identification-card/${this.empCodes}`)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    EventBus.$on("SELECTED_EMPLOYEE", payload => {
      var empCodes = payload.map(item => {
        return item.empCode;
      });
      this.selectedEmployees = empCodes;
    });
  }
};
</script>